<template>
  <div>
    <info></info>
    <!-- <num class="mt10"></num> -->
    <el-row :gutter="20" class="mt10">
      <el-col :span="12"><meet></meet></el-col>
      <el-col :span="12"><help></help></el-col>
    </el-row>
  </div>
</template>

<script>
import Info from './components/Info.vue';
// import Num from './components/Num.vue';
import Meet from './components/Meet.vue';
import Help from './components/Help.vue';

export default {
  components: {
    Info,
    Meet,
    Help
  },
  methods: {}
};
</script>

<style lang="scss">
.item {
  font-size: 14px;
  margin-bottom: 18px;
}
.box-card {
  height: 300px;
  .tip {
    float: right;
    padding: 3px 0;
  }
}
</style>
